import dayjs from "dayjs";
import { SearchByRefNumberResult } from "../../types/equipment-inventory/liveInventory.type";

export const mockSearchByRefData = {
  default: {
    available: [
      {
        equipmentId: 24891,
        refNumber: "ONT138T3",
        doorNumber: null,
        status: { id: 20, name: "EMTY" },
        assignedTo: null,
        homeSicId: 111,
        loadSummary: { bills: 0, weight: 0, pallets: 0, pieces: 0 },
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: 43,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: dayjs("2024-01-14 09:00"),
        daysAging: 420,
      },
      {
        equipmentId: 25082,
        refNumber: "ONTGHOST01",
        doorNumber: null,
        status: { id: 20, name: "EMTY" },
        assignedTo: null,
        homeSicId: 111,
        loadSummary: { bills: 0, weight: 0, pallets: 0, pieces: 0 },
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: null,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: dayjs("2024-01-08 20:39:12"),
        daysAging: 113,
      },
    ],
    assigned: [
      {
        equipmentId: 24325,
        refNumber: "ONTGHOST02",
        doorNumber: "130",
        status: { id: 26, name: "ENRT" },
        assignedTo: {
          id: 3094839,
          type: "trip",
          name: "3094839",
        },
        homeSicId: 111,
        loadSummary: { bills: 2, weight: 958, pallets: 7, pieces: 0 },
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: null,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: "S-GERALDO-1",
        lastUpdateDate: dayjs("2024-01-08 20:39:12"),
        daysAging: 1,
      },
      {
        equipmentId: 24638,
        refNumber: "ONTGHOST36",
        doorNumber: null,
        status: { id: 221, name: "DEPT" },
        assignedTo: null,
        homeSicId: 111,
        loadSummary: { bills: 0, weight: 0, pallets: 0, pieces: 0 },
        equipmentType: { id: 2, name: "Trailer" },
        lengthFt: null,
        ownership: { ownershipType: "C", ownershipScacCode: null },
        currentSealNumber: null,
        lastUpdateDate: dayjs("2024-01-08 20:39:12"),
        daysAging: 76,
      },
    ],
    loadAndHold: [],
  },
} as const satisfies Record<string, SearchByRefNumberResult>;
